module.exports = __webpack_public_path__ + "img/hodo.f503748c.png";